import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  f,
  gs,
  ls,
  useMsgz,
  LgnNbrC,
  RootC,
  GridC,
  TextC,
  _cv_31___Mz,
  _cv_10___Mz,
  cmLSG,
  cmWEB,
  useGblz,
} from 'lib';
*/
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LgnNbrC from "./_ccmLgnNbrC";
import * as RootC from "./_ccmRootC";
import * as cmLSG from "./_cmLSG";
import * as cmWEB from "./_cmWEB";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icvI18___Mz from './icvI18___Mz';
import * as icvI19___Mz from './icvI19___Mz';
import FtrC from './IccvFtr';
import * as icm from './icm';
import * as icv from './icv';

let $cky = true;

export const N = () => {

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

  const _sPz = ls.usePagez({
    steps: [0],
  });

  const _sMsgz = useMsgz();

  React.useEffect(() => {

    cmLSG.chkAsync()
    .then((_b: ht.b) => {
      $cky = _b;
    });

    const $id = cmWEB.getPmrz('id') ?? '';
    const _i18r_fst = hf.cvtNbr('d', $id, icv.srtz.nbrz1);
    icvI18___Mz.loadI18rDzAsync({
      i18r_fst: Number(_i18r_fst),
      bDmn: false,
    })
    .then( async (_i18z: ht.dz) => {

//hf.l(`ccmLgnD40Rz 55: here`)

      await _gUserz.saveAsync({
        _dmn: _i18z.i18rz._dmn
      });

//hf.l(`ccmLgnD40Rz 61: here`)

      await icm.setStgzAsync({
        _31r_fst: 0,
        i18r_fst: Number(_i18r_fst),
      });

      _sPz.udtAll();

    });

//hf.l(`ccmLgnD40Rz 67: here`)
  //hf.l(`ccmLgnD40Rz 110: ${hf.s(_dz)}`)

  }, [
  ]);

  const _atrCfm = async (
    _i18r_fst: ht.n
  ) => {
    //hf.l(`icvLgnD14Rz 59: ${_i18r_fst}`);
    const _i18z = await icvI18___Mz.loadI18rDzAsync({
      i18r_fst: _i18r_fst,
      bDmn: false,
    });
    //hf.l(`icvLgnD40Rz 64: ${hf.s(_i18z)}`);
    if (hf.f(_i18z.i18rz)) {
      await _gUserz.saveAsync({
        _dmn: _i18z.i18rz._dmn,
      });
      //hf.l(`icvLgnD40Rz 193: ${hf.s(_i18z)}`);
      const _i19z = await icvI19___Mz.loadI19rDzAsync({
        i19r_dmn: _i18z.i18rz._dmn,
      });
      const __31z = await _cv_31___Mz.load_31rDzAsync({
        _31r_fst: _i18z.i18rz.i18r_31r1f,
      });      
      const __10z = await _cv_10___Mz.load_10rDzAsync({
        _10r_icn: `${_i18r_fst}_1`,
      });
      //hf.l(`icvLgnD40Rz 193: ${hf.s(__31z)}`);
      await _gUserz.saveAsync({
        //_dmn: _i18z.i18rz._dmn,
        i19rz: _i19z.i19rz,
        _20rz: _i19z._20rz,
        i18rz: _i18z.i18rz,
        _31rz: __31z._31rz,
        _10rz: __10z._10rz,
      });
      await _gUserz.saveAsync({
        usrClr: 'bl',
      });
      cr.moveTo({
//        pageName: 'icvHomeD20Rz',
        pageName: 'icvI18D20Rz',
      })
    }
    else {
      _sMsgz.show({
        textCz: {
          textz: {
            pfx: '「初期設定用確認コード」または「URL」が誤っているため、認証に失敗しました',
          }
        }
      })
    }
  };

  //hf.l(`ccmLgnD40Rz 105: ${_gStgz.crt.S03031213}`)
  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        boxStlz: a(`f/n`),
        oClds: [

          cr.c(GridC.N, {
            key: -20,
            abtType: 'lgnCmnz',
            boxStlz: 
              cr.chkDvc() == 'p' ?
                undefined
              : a('f/n fd/csc'),
            lineCs: [
              {
                boxStlz: a('dw/f sc/bl7'),
                cellCs: [
                ]
              },
              {
                boxStlz: a('dw/f dh/10 f/n mb/4 sc/bl7'),
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'lgnHdgDntz',
                        textz: {
                          pfx: `施設利用予約　初期設定`,
                          stlz: a('ta/c tc/lt1'),
                        },
                      }),
                    ]
                  }
                ]
              },
              {
                boxStlz: a('dw/f dwx/100 f/n mb/4 ph/2'),
                cellCs: [                
                  {
                    boxStlz: a('bc/lt3 br/1 bw/2 dw/f fd/ccc p/2'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx: _gStgz.crt.S03031111
                        },
                      }),

                    ]
                  }
                ]
              },
              //_gStgz.crt.S03031213 == '1' ?
              {
                boxStlz: a('f/n mb/4 ph/2'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx: '▼ 別紙の初期設定用確認コードを入力し、[送る]ボタンを押してください。',
                        },
                      }),

                    ]
                  }
                ]
              },
              //: null,
              //_gStgz.crt.S03031213 == '1' ?
              {
                boxStlz: a('f/n mb/4'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(LgnNbrC.N, {
                        key: -10,
                        cz: {
                          ccd: 'bl7',
                          pfx: '初期設定用確認コード',
                          atrCfm: _atrCfm,
                        }
                      })

                    ]
                  }
                ]
              },
              //: null,
              //_gStgz.crt.S03031213 == '1' ?
              {
                boxStlz: a('f/n ph/2'),
                cellCs: [
                  {
                    oClds: [

                      $cky == false ?
                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx: '※ ブラウザのクッキーを有効にしてください。',
                          stlz: a('tc/rd6 ts/s'),
                        },
                      })
                      : null,

                      cr.c(TextC.N, {
                        key: -20,
                        textz: {
                          pfx: '※ 初期設定用確認コードが不明な場合は、窓口までお問い合わせください。',
                          stlz: a('ts/s'),
                        },
                      }),

                      cr.c(TextC.N, {
                        key: -30,
                        textz: {
                          pfx: '※ 本システムは、最新版の Chrome, Safari, Edge, FireFox にてご利用いただけます。',
                          stlz: a('ts/s'),
                        },
                      }),
                    ]
                  }
                ]
              },
              //: null,              
              {
                boxStlz:
                  cr.chkDvc() == 'p' ? 
                    a('f/2')
                  : a('f/n'),
                cellCs: [
                ]
              },
            ]
          }),

          cr.c(FtrC, {
            key: -30,
          })
        ],
      },
    })
  );
};
